export default "__VITE_ASSET__DMrVU3k$__"